import { render, staticRenderFns } from "./PartertermsUSA.vue?vue&type=template&id=5105237e&scoped=true"
import script from "./PartertermsUSA.vue?vue&type=script&lang=js"
export * from "./PartertermsUSA.vue?vue&type=script&lang=js"
import style0 from "./PartertermsUSA.vue?vue&type=style&index=0&id=5105237e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5105237e",
  null
  
)

export default component.exports